import { usePublicApolloClient } from '../../api/usePublicApolloClient.js'
import { usePickupClient } from '../../api/usePickupClient.js'
import SearchItemsQuery from '../../../../graphqls/public/queries/search_items.js'
import {
  toSearchResult,
  toCategories,
  toScenes,
  toReceivingKinds
} from './itemSearchMapper.js'

/** @typedef {import('./searchConditions.js').SearchConditions} SearchConditions */
/** @typedef {import('../../mappers/itemMapper.js').Item} Item */
/** @typedef {import('./itemSearchMapper.js').Pagination} Pagination */

/**
 * @returns {{fetchItems: Function, fetchCategories: Function, fetchScenes: Function, fetchReceivingKinds: Function}}
 */
export const useItemSearchApi = () => {
  const { client } = usePublicApolloClient()
  const pickupClient = usePickupClient()

  /**
   * @param {SearchConditions} conditions
   * @param {number} pageNumber
   * @returns {Promise<{items: Item[], pagination: Pagination}>}
   */
  const fetchItems = async (conditions, pageNumber) => {
    const response = await client.query({
      query: SearchItemsQuery,
      variables: {
        keyword: conditions.keyword,
        pageNumber,
        itemPerPage: 30,
        itemReceivingKindIds: conditions.selectedReceivingKindIds,
        sortKey: conditions.sortSelectedValue,
        sceneIds: conditions.selectedSceneIds,
        categoryIds: conditions.selectedCategoryIds,
        stringLowerBudget: conditions.lowerBudget?.toString() ?? null,
        stringHigherBudget: conditions.higherBudget?.toString() ?? null
      }
    })
    return toSearchResult(response.data.searchItems)
  }

  const fetchCategories = async () => {
    return toCategories(await pickupClient.get('item_categories'))
  }

  const fetchScenes = async () => {
    return toScenes(await pickupClient.get('scenes'))
  }

  const fetchReceivingKinds = async () => {
    return toReceivingKinds(await pickupClient.get('item_receiving_kinds'))
  }

  return { fetchItems, fetchCategories, fetchScenes, fetchReceivingKinds }
}
